import { IWorldNftEvent } from '../types/world-nft-event.types';

import prizePoolImage1 from 'assets/single-event/prize-pool/first.png';
import prizePoolImage4 from 'assets/single-event/prize-pool/fourth.png';
import worldNftPrizePoolImage3 from 'assets/single-event/prize-pool/gdp.png';
import prizePoolHighlightImage1 from 'assets/single-event/prize-pool/highlight_1.png';
import prizePoolHighlightImage2 from 'assets/single-event/prize-pool/highlight_2.png';
import prizePoolHighlightImage3 from 'assets/single-event/prize-pool/highlight_3.png';
import worldNftPrizePoolImage2 from 'assets/single-event/prize-pool/paris.png';
import worldNftPrizePoolImage4 from 'assets/single-event/prize-pool/question.png';
import prizePoolImage2 from 'assets/single-event/prize-pool/second.png';
import prizePoolImage3 from 'assets/single-event/prize-pool/third.png';
import worldNftPrizePoolImage1 from 'assets/single-event/prize-pool/usa.png';
import worldNftPrizePoolHighlightImage1 from 'assets/single-event/prize-pool/wnft_highlight_1.png';
import worldNftPrizePoolHighlightImage2 from 'assets/single-event/prize-pool/wnft_highlight_2.png';
import worldNftPrizePoolHighlightImage3 from 'assets/single-event/prize-pool/wnft_highlight_3.png';
import RMVChampionTrophy from 'assets/single-event/rmv-champion-trophy.png';
import singleEventBg from 'assets/single-event/single_event_bg_1x.png';
import worldNftCardImage from 'assets/single-event/world-nft-card.png';

const generateMockEvent = (): Record<string, IWorldNftEvent> => {
  const pastTimestamp = Math.floor(new Date('2025-09-30T00:00:00Z').getTime() / 1000);
  const futureTimestamp0 = Math.floor(new Date('2025-11-06T00:00:00Z').getTime() / 1000);
  const futureTimestamp1 = Math.floor(new Date('2026-11-30T23:59:59Z').getTime() / 1000);
  const futureTimestamp2 = Math.floor(new Date('2026-12-31T23:59:59Z').getTime() / 1000);
  const currentTimestamp = Math.floor(Date.now() / 1000);

  return {
    'api/event/world-nft': {
      id: 'world-nft',
      intro: {
        backgroundImage: singleEventBg,
        heroImage: worldNftCardImage,
        heroImageClassName: 'tw-h-[388px] tw-w-[297px]',
        title: 'World NFT',
        subtitle: 'INSANE CHANCE TO GET __40+ NFT AIRDROPS__!',
      },
      endAt: futureTimestamp2,
      stages: [
        {
          id: 1,
          name: 'REGISTRATION STARTS',
          timestamp: pastTimestamp,
        },
        {
          id: 2,
          name: 'COMPETITION STARTS',
          timestamp: futureTimestamp0,
        },
        {
          id: 3,
          name: 'REGISTRATION ENDS',
          timestamp: futureTimestamp1,
        },
        {
          id: 4,
          name: 'COMPETITION ENDS',
          timestamp: futureTimestamp2,
        },
        {
          id: 5,
          name: 'REWARDS DISTRIBUTION',
          timestamp: futureTimestamp2,
          description: 'Every week and month',
        },
      ],
      prizePool: [
        {
          image: worldNftPrizePoolImage1,
          name: 'United States X1',
        },
        {
          image: worldNftPrizePoolImage2,
          name: 'Paris X1',
        },
        {
          image: worldNftPrizePoolImage3,
          name: 'TOP15 GDP Package X1',
        },
        {
          image: worldNftPrizePoolImage4,
          name: '23+ Other Legendary NFTs',
        },
      ],
      prizePoolHighlights: [
        {
          image: worldNftPrizePoolHighlightImage1,
          name: 'Zero Dilution',
          value: '5K WNFT MAX',
          label: 'Fixed supply guaranteed forever',
        },
        {
          image: worldNftPrizePoolHighlightImage2,
          name: 'VIP Group',
          value: 'YES',
          label: 'Each owner of 5 wNFT has access to the group',
        },
        {
          image: worldNftPrizePoolHighlightImage3,
          name: 'Total Guaranteed Rewards',
          value: '40+ NFTS',
          label: 'Total NFTs for early holders',
        },
      ],
      myStatistics: {
        statistics: [
          {
            name: 'Amount of World NFTs Owned',
            value: '<<world-nft-balance>>',
          },
        ],
        lastUpdated: currentTimestamp,
        estimatedReward: [
          {
            image: worldNftPrizePoolImage1,
            name: 'United States X<<world-nft-balance>>',
          },
          {
            image: worldNftPrizePoolImage2,
            name: 'Paris X<<world-nft-balance>>',
          },
          {
            image: worldNftPrizePoolImage3,
            name: 'TOP15 GDP Package X<<world-nft-balance>>',
          },
          {
            image: worldNftPrizePoolImage4,
            name: '<<world-nft-balance(23)>>+ Other Legendary NFTs',
          },
        ],
      },
      secondaryLeaderboard: {
        title: 'August 2026 Event',
        subtitle: 'HOLD YOUR WNFT — FOUR MONTHLY AIRDROPS',
        description:
          'Each airdrop delivers the full set below to every holder.\n No action required — just hold and collect.',
        enablePagination: false,
        columns: [
          { key: 'airdrop', header: 'AIRDROP' },
          { key: 'date', header: 'DATE' },
          { key: 'reward', header: 'REWARD' },
          { key: 'status', header: 'STATUS' },
        ],
        items: [
          {
            airdrop: '1',
            date: 'September',
            reward: 'United States x 1\nParis x 1\nTokyo x 1\nItaly x 1\nGreat Wall at Mutianyu x 1\nTBA x 1',
            status: 'SCHEDULED',
          },
          {
            airdrop: '2',
            date: 'October',
            reward: 'Egypt x 1\nChina x 1\nStatue of Liberty x 1\nForbidden City x 1\nGermany x 1\nTBA x 1',
            status: 'SCHEDULED',
          },
          {
            airdrop: '3',
            date: 'November',
            reward: 'Notre Dame x 1\nMexico City x 1\nAbu Dhabi x 1\nHong Kong x 1\nMontreal x 1\nTBA x 1',
            status: 'SCHEDULED',
          },
          {
            airdrop: '4',
            date: 'December',
            reward:
              "Prague Astronomical Clock x 1\nKing's Palace x 1\nMdO Paris Art Museum x 1\nTBA\nTBA\nTop 15 GDP Package",
            status: 'SCHEDULED',
          },
        ],
      },
      leaderboard: {
        title: '1st & 2nd Event',
        subtitle: 'AIRDROP SCHEDULE — THE EARLIER YOU HOLD, THE MORE YOU RECEIVE',
        description:
          'Every WNFT holder receives premium NFTs on the following schedule.\n No action required — just hold and collect.',
        enablePagination: false,
        columns: [
          { key: 'airdrop', header: 'AIRDROP' },
          { key: 'date', header: 'DATE' },
          { key: 'reward', header: 'REWARD' },
          { key: 'status', header: 'STATUS' },
        ],
        items: [
          { airdrop: '1', date: 'Oct 9 2025', reward: 'United States x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '2', date: 'Oct 16 2025', reward: 'Paris x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '3', date: 'Oct 23 2025', reward: 'Tokyo x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '4', date: 'Oct 30 2025', reward: 'Italy x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '5', date: 'Nov 6 2025', reward: 'Great Wall at Mutianyu x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '6', date: 'Nov 13 2025', reward: 'Egypt x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '7', date: 'Nov 20 2025', reward: 'China x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '8', date: 'Nov 27 2025', reward: 'Statue of Liberty x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '9', date: 'Dec 4 2025', reward: 'Forbidden City x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '10', date: 'Dec 11 2025', reward: 'Germany x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '11', date: 'Dec 18 2025', reward: 'Notre-Dame x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '12', date: 'Dec 22 2025', reward: 'Mexico City x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '13', date: 'January 2026', reward: 'Abu Dhabi x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '14', date: 'February 2026', reward: 'Hong Kong x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '15', date: 'March 2026', reward: 'Montreal x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '16', date: 'April 2026', reward: 'Prague Astronomical Clock x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '17', date: 'May 2026', reward: "King's Palace x1", status: '~~DISTRIBUTED~~' },
          { airdrop: '18', date: 'Jun 2026', reward: 'MdO Paris Art Museum x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '19', date: 'July 2026', reward: 'Rome x1', status: '~~DISTRIBUTED~~' },
          { airdrop: '20', date: 'August 2026', reward: 'TBA', status: 'SCHEDULED' },
          { airdrop: '21', date: 'September 2026', reward: 'TBA', status: 'SCHEDULED' },
          { airdrop: '22', date: 'October 2026', reward: 'TBA', status: 'SCHEDULED' },
          { airdrop: '23', date: 'November 2026', reward: 'TBA', status: 'SCHEDULED' },
          {
            airdrop: '24',
            date: 'December 2026',
            reward: 'Top 15 GDP Package',
            status: 'SCHEDULED',
            isCurrentUser: true,
          },
        ],
      },
      rankingRules: {
        title: 'Rules for ranking rewards',
        description:
          'During the event, the top 60 participants with the highest total Futures Trading Volume will share a 50,000 USDT prize pool.',
        ranges: [],
      },
      participationCriteria: [
        {
          name: 'Qualifying WNFT Purchases',
          value:
            'Only WNFT purchased through the official World NFT Event, directly from Reality Metaverse, or from other approved Reality Metaverse distribution wallets qualify for event rewards.\nPurchases made from __July 1, 2026__ onward are eligible, including purchases completed before the official event launch on __August 20, 2026__.',
        },
        {
          name: 'July 1 Snapshot',
          value:
            'A snapshot of WNFT holdings was taken on __July 1, 2026__.\nWNFT already held at the time of the snapshot do not qualify for the 2026 event rewards. They remain part of your total WNFT balance but are excluded from your __Event Qualifying WNFT__ balance.',
        },
        {
          name: 'Limited Event Allocation',
          value:
            'Starting __August 24, 2026__, a maximum of __250 WNFT__ will be available for participation in the 3rd World NFT Event — August 2026.\nOnly qualifying WNFT purchased while this allocation remains available will be eligible for the event. Once all 250 WNFT have been allocated, no additional WNFT purchases will be accepted into the August 2026 event.',
        },
        {
          name: 'Buy & Hold',
          value:
            'Your rewards are based on the number of qualifying WNFT you continue to hold.\nIf qualifying WNFT leave your registered wallet or approved linked wallets, your __Event Qualifying WNFT__ balance will be reduced accordingly.\n\n**Example:**\nYou owned 20 WNFT on July 1.\nYou purchase 5 WNFT through the event.\nTotal WNFT: 25\nEvent Qualifying WNFT: __5__\n\nIf you later transfer or sell 2 WNFT outside your approved wallets:\nEvent Qualifying WNFT: __3__',
        },
        {
          name: 'Secondary Market Purchases',
          value:
            'WNFT purchased from marketplaces, other users, or any non-approved source do not increase your __Event Qualifying WNFT__ balance.\nBuying WNFT back from the secondary market after selling or transferring qualifying WNFT will not restore their event eligibility.\nTo increase your qualifying balance again, additional WNFT must be purchased through an approved World NFT Event source.',
        },
        {
          name: 'Approved Wallet Transfers',
          value:
            'Users may register approved wallets connected to their account.\nTransfers of WNFT between your approved registered wallets do not reduce your qualifying balance.\nTransfers to wallets outside your approved wallet group are treated as WNFT leaving your event position and may reduce your qualifying balance.',
        },
        {
          name: 'Monthly Airdrops',
          value:
            'Before every monthly reward distribution, the system determines the number of __Event Qualifying WNFT__ held by your account.\nYour reward tier is based on this qualifying balance — not your total WNFT holdings.\n\n**For example:**\nTotal WNFT Held: 35\nEvent Qualifying WNFT: __5__\nYour monthly reward will be calculated using 5 WNFT.',
        },
        {
          name: 'Continuous Holding & Grand Airdrop',
          value:
            'The Grand Airdrop rewards participants who maintain their qualifying WNFT throughout the required event period.\nYour Grand Airdrop tier is determined by the qualifying WNFT balance continuously maintained during the campaign.\nIf your qualifying balance decreases, your Grand Airdrop tier may also decrease.\nPurchasing additional WNFT later can increase your current qualifying balance, but it does not retroactively restore a previously broken holding level for the Grand Airdrop.',
        },
      ],
    },
  };
};

const mock = generateMockEvent();

export default mock;
